<div class="validation-modal">
  <header class="validation-modal-header">
    <div class="validation-modal-header-copy">
      <h2 class="validation-modal-title" tabindex="-1" cdkFocusInitial>Estado de validación</h2>
      <p class="validation-modal-sub" *ngIf="signerName">{{ signerName }}</p>
    </div>
    <button type="button" class="validation-close-x" (click)="close()" aria-label="Cerrar">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </header>

  <div class="validation-modal-body">
    <div class="validation-status" [class.valid]="valid" [class.invalid]="!valid" role="status" aria-live="polite">
      <div class="validation-icon" aria-hidden="true">
        <i class="fas" [ngClass]="valid ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
      </div>
      <div class="validation-status-text">
        <p class="validation-text" *ngIf="valid">
          <strong>Firma válida.</strong>
          Documento sin modificaciones e identidad del firmante correcta.
        </p>
        <p class="validation-text" *ngIf="!valid">
          <strong>Firma no válida.</strong>
          {{ cert?.serviceMessage || 'Revise el documento o el certificado del firmante.' }}
        </p>
      </div>
    </div>

    <div class="validation-meta-grid" *ngIf="cert">
      <div class="validation-meta-item" *ngIf="cert.serial && cert.serial !== 'N/A'">
        <span class="validation-meta-label">Serial</span>
        <span class="validation-meta-value mono">{{ cert.serial }}</span>
      </div>
      <div class="validation-meta-item" *ngIf="issuerSummary">
        <span class="validation-meta-label">Emisor</span>
        <span class="validation-meta-value">{{ issuerSummary }}</span>
      </div>
      <div class="validation-meta-item">
        <span class="validation-meta-label">Última comprobación</span>
        <span class="validation-meta-value mono">{{ formatLastCheckDate(lastCheckDate) }}</span>
      </div>
    </div>

    <button
      type="button"
      class="validation-details-toggle"
      (click)="toggleDetails()"
      [attr.aria-expanded]="detailsOpen">
      <i class="fas fa-chevron-down" [class.open]="detailsOpen" aria-hidden="true"></i>
      Detalles de la firma
    </button>
    <div class="validation-details-body" *ngIf="detailsOpen">
      <p class="validation-detail-line">{{ timestampDetailText }}</p>
      <p class="validation-detail-line">{{ ltvDetailText }}</p>
    </div>
  </div>

  <footer class="validation-actions">
    <button type="button" class="btn-close-modal" (click)="close()">Cerrar</button>
    <button type="button" class="btn-props" (click)="openCertificateProperties()" *ngIf="cert">
      Propiedades…
    </button>
  </footer>
</div>
